<template>
  <b-dropdown
    aria-role="list"
    position="is-bottom-left"
    :triggers="['hover']"
    :delay="300"
  >
    <template #trigger>
      <button-tooltip
        tooltip="Filter by Status"
        position="is-bottom"
        :label="statusLabel"
        type="is-info is-light"
        size="is-small"
        outlined
      />
    </template>

    <b-dropdown-item
      v-for="status in statusOptions"
      :key="status"
      :value="status"
      aria-role="listitem"
      @click="toggleStatus(status)"
    >
      <TopicStatusBadge :status="status" />
      ({{ getStatusCount(status) }})
      <b-icon
        v-if="selectedStatuses.includes(status)"
        icon="check"
        class="has-text-success"
      />
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";
import TopicStatusBadge from "../atoms/TopicStatusBadge.vue";
import { ContentStatus } from "vue-chess-shared";

export default {
  name: "StatusFilter",

  components: {
    ButtonTooltip,
    TopicStatusBadge,
  },

  props: {
    scenarios: {
      type: Array,
      required: true,
    },
    selectedStatuses: {
      type: Array,
      default: () => [ContentStatus.Draft, ContentStatus.Published],
    },
  },

  data() {
    return {
      statusOptions: [
        ContentStatus.Draft,
        ContentStatus.Published,
        ContentStatus.Archived,
      ],
    };
  },

  computed: {
    filteredCount() {
      return (
        this.scenarios.filter((scenario) =>
          this.selectedStatuses.includes(scenario.status)
        ).length || 0
      );
    },

    statusLabel() {
      // Build label with icons of selected statuses
      let label = "";

      if (this.selectedStatuses.includes(ContentStatus.Draft)) {
        label += "📝";
      }
      if (this.selectedStatuses.includes(ContentStatus.Published)) {
        label += "📢";
      }
      if (this.selectedStatuses.includes(ContentStatus.Archived)) {
        label += "📦";
      }

      // Add count of filtered scenarios
      label += ` (${this.filteredCount})`;

      return label;
    },
  },

  methods: {
    toggleStatus(status) {
      // Create a copy of the selected statuses
      const newSelectedStatuses = [...this.selectedStatuses];

      // Toggle the status
      const index = newSelectedStatuses.indexOf(status);
      if (index === -1) {
        // Add the status if it's not already selected
        newSelectedStatuses.push(status);
      } else {
        // Remove the status if it's already selected, but ensure at least one status remains selected
        if (newSelectedStatuses.length > 1) {
          newSelectedStatuses.splice(index, 1);
        }
      }

      // Emit the updated statuses
      this.$emit("update-statuses", newSelectedStatuses);
    },

    getStatusCount(status) {
      return this.scenarios.filter((s) => s.status === status).length || 0;
    },
  },
};
</script>

<style scoped></style>
